import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import store from '@/store';
import Client from '@/models/Client';
import SetupStatus from '@/models/SetupStatus';
import ClientService from '@/services/ClientService';

@Module({
  namespaced: true,
  name: 'clients',
  store,
  dynamic: true,
})
class ClientModule extends VuexModule {
  public currentClient!: Client;
  public pendingClientsList!: Client[];
  public summary!: SetupStatus[];
  public step!: number;
  public service: ClientService = new ClientService();
  public holdedClients!: any[];
  public setupClients!: any[];

  @Action({ rawError: true, commit: 'saveClient' })
  public async firstStep(payload: {
    id: Number;
    clientId: string;
    restaurantName: string;
    projectKey: string;
    alreadyExisting: boolean;
    deliverySetup: boolean;
    clientSetup: boolean;
  }) {
    const res = await this.service.createClient(payload);
    if (res.status === 201) {
      return res.data.client;
    } else {
      return res;
    }
  }

  @Mutation
  public saveClient(client: Client) {
    this.currentClient = client;
    this.step = 1;
  }

  @Action({ rawError: true, commit: 'storeClient' })
  public async secondStep(payload: {
    mangoPay: string;
    deliveryService: string;
    fbAppId: string;
    fbAppPwd: string;
    gaTrackingId: string;
    clientId: string;
    deliverySetup: boolean;
    clientSetup: boolean;
  }) {
    const res = await this.service.setSecurity(payload);
    if (res.status === 200) {
      return res.data;
    } else {
      return res;
    }
  }

  @Action({ rawError: true, commit: 'storeClient' })
  public async getOneClient(payload: { id: string }) {
    const res = await this.service.getClient(payload);
    if (res.status === 200) {
      return res.data;
    } else {
      return res;
    }
  }

  @Mutation
  public storeClient(client: Client): void {
    this.currentClient = client;
    this.step = 2;
  }

  @Action({ rawError: true, commit: 'setSummary' })
  public async getStatusSummary() {
    const res = await this.service.getStatusSummary();
    if (res.status === 200) {
      return res.data.status;
    } else {
      return res;
    }
  }

  @Action({ rawError: true, commit: 'setPendingClientsList' })
  public async getPendingClients() {
    const res = await this.service.getPendingClients();
    if (res.status === 200) {
      return res.data.pendingClients;
    } else {
      return res;
    }
  }

  @Mutation
  public setSummary(status: any[]): void {
    this.summary = [];
    status.forEach((item) =>
      this.summary.push((new SetupStatus().fromJson = item)),
    );
  }

  @Action({ rawError: true, commit: 'setHoldedClients' })
  public async getClients() {
    try {
      const res = await this.service.getClients();
      if (res.status === 200) {
        return res.data.clients;
      } else {
        return `Getting holded clients failed: ${res.data.error}`;
      }
    } catch (error) {
      return error;
    }
  }

  @Mutation
  public setHoldedClients(clients: Client[]): void {
    if (clients instanceof Array) {
      this.setClients = clients;
    } else {
      this.setClients = [];
    }
  }

  @Action({})
  public async createHoldedContact(payload: {
    id: number;
    billingAddress: any;
  }) {
    const res = await this.service.createHoldedContact(payload);
    return res;
  }

  @Action
  public async generateInvoice(payload) {
    return await this.service.generateInvoice(payload);
  }

  @Action
  public async editClient(payload) {
    return await this.service.editClient(payload);
  }

  @Action
  public async deleteClient(payload) {
    return await this.service.deleteClient(payload);
  }

  @Action
  public async getReports() {
    return await this.service.retrieveReports();
  }

  @Mutation
  public setPendingClientsList(pendingClients: any[]): void {
    this.pendingClientsList = [];
    pendingClients.forEach((item) => {
      this.pendingClientsList.push((new Client().fromJson = item));
    });
  }

  get getSummary(): SetupStatus[] {
    return this.summary;
  }

  get getClient(): Client {
    return this.currentClient;
  }

  set setClients(clients: any[]) {
    this.setupClients = clients;
  }

  get clients(): Client[] {
    return this.setupClients;
  }

  get getPendingClientsList(): Client[] {
    return this.pendingClientsList;
  }
}

export default getModule(ClientModule);
